module.exports = __webpack_public_path__ + "img/mew-icon.fa1a0713.png";